import { $api } from "./instance";
import { PATH } from "./path";

export class ApiService {
  static async getContentForForm() {
    const { data } = await $api.get("/api/front/content");
    return data;
  }

  static getCacheSSR(contentId) {
    return $api.get(`/ssr/cache/${contentId}`);
  }

  static getPageContent(tag, languageCode) {
    return $api.get("/api/front/content/page", {
      params: { tag, languageCode },
    });
  }

  static getCountryInfo(countryName, languageCode) {
    return $api.get("/api/front/country-meta-data", {
      params: { languageCode, countryName },
    });
  }

  static getAllCountries(languageCode) {
    return $api.get("/api/front/countries", {
      params: { languageCode },
    });
  }

  static getMenuProxy(languageCode) {
    return $api.get("/api/front/proxy-provider-references", {
      params: { languageCode },
    });
  }

  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} [params.englishCountryName] - The country ID (optional).
   * @param {String} [params.proxyType] - The proxy type (optional).
   * @param {Boolean} [params.google] - Whether Google proxies are required (optional).
   * @param {String} [params.sortField] - The field to sort by (optional).
   * @param {String} [params.sortDirection] - The sort direction (optional).
   * @returns {Promise<Object>}
   */

  static async getProxyServers(params) {
    const { data } = await $api.post("/api/front/proxies", params);
    return data;
  }

  /**
   * @param {Object} params
   * @param {Number} params.page
   * @param {Number} params.size
   * @param {String} [params.countryId] - The country ID (optional).
   * @param {String} [params.proxyType] - The proxy type (optional).
   * @param {Boolean} [params.google] - Whether Google proxies are required (optional).
   * @param {String} [params.sortField] - The field to sort by (optional).
   * @param {String} [params.sortDirection] - The sort direction (optional).
   * @returns {Promise<Object>}
   */

  static async getPaginationProxyServers(params) {
    const { data } = await $api.post("/api/front/proxy-pagination", params);
    return data;
  }

  static getHeaders(url) {
    return $api.get(PATH.headers, {
      params: { url: url },
    });
  }

  static getProxiesForExports(params) {
    return $api.post(PATH.exportProxies, params);
  }

  static getBlogArticle(slug) {
    return $api.get(`${PATH.blogArticle}/${slug}`);
  }

  static getBlogFacts(languageCode) {
    return $api.get(PATH.blogFacts, {
      params: { languageCode },
    });
  }

  static getBlogContent(params) {
    return $api.post(PATH.blog, params);
  }

  static postSubscribe(email) {
    return $api.post(PATH.subscribe, email);
  }

  static getHTMLCode() {
    return $api.get(PATH.html);
  }

  static async getActiveLanguages() {
    const { data } = await $api.get(PATH.languages);
    return data;
  }
}
